var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordionItem"},[_c('input',{attrs:{"type":"checkbox","id":this._uid}}),_vm._v(" "),_c('label',{attrs:{"for":this._uid}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }